var _path, _path2, _path3, _path4, _path5, _rect;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgImg3(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 148,
    height: 148,
    viewBox: "0 0 148 148",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M96.882 101.331H46.712C41.7298 101.331 37.6906 97.292 37.6906 92.3098C37.6906 87.3276 41.7298 83.2883 46.712 83.2883H88.1118C92.955 83.2883 96.8802 79.3631 96.8802 74.5199C96.8802 69.6767 92.955 65.7516 88.1118 65.7516H46.712C41.7298 65.7498 37.6906 61.7105 37.6906 56.7283C37.6906 51.746 41.7298 47.7068 46.712 47.7068H96.882",
    stroke: "#E17D55",
    strokeWidth: 0.9,
    strokeMiterlimit: 10
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M105.988 51.6445H97.8957C97.2433 51.6445 96.7139 51.115 96.7139 50.4626V44.9011C96.7139 44.2487 97.2433 43.7192 97.8957 43.7192H105.988C106.641 43.7192 107.17 44.2487 107.17 44.9011V50.4644C107.17 51.1168 106.641 51.6445 105.988 51.6445Z",
    stroke: "#E17D55",
    strokeWidth: 0.9,
    strokeMiterlimit: 10
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M109.962 49.7066H107.338V45.6584H109.962C110.608 45.6584 111.132 46.1825 111.132 46.8278V48.5355C111.132 49.1826 110.608 49.7066 109.962 49.7066Z",
    stroke: "#E17D55",
    strokeWidth: 0.9,
    strokeMiterlimit: 10
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M105.988 105.103H97.8957C97.2433 105.103 96.7139 104.574 96.7139 103.921V98.3581C96.7139 97.7057 97.2433 97.1763 97.8957 97.1763H105.988C106.641 97.1763 107.17 97.7057 107.17 98.3581V103.921C107.17 104.574 106.641 105.103 105.988 105.103Z",
    stroke: "#E17D55",
    strokeWidth: 0.9,
    strokeMiterlimit: 10
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M109.962 103.164H107.338V99.1172H109.962C110.608 99.1172 111.132 99.6413 111.132 100.287V101.994C111.132 102.64 110.608 103.164 109.962 103.164Z",
    stroke: "#E17D55",
    strokeWidth: 0.9,
    strokeMiterlimit: 10
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 147,
    height: 147,
    rx: 73.5,
    stroke: "#E17D55"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgImg3);
export default __webpack_public_path__ + "static/media/img3.00b69abd23554dda19f989b25d942e0f.svg";
export { ForwardRef as ReactComponent };